// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import { ToastContextData } from "@insite/mobius/Toast/ToasterContext";

export const getDocumentsWrapper = async <TGetterParams>(
    documentGetter: (params: TGetterParams) => Promise<void>,
    stateSetter: (value: React.SetStateAction<boolean>) => void,
    queryParameters: TGetterParams,
    toasterContext?: ToastContextData,
    errorMessage?: string,
) => {
    stateSetter(true);

    try {
        await documentGetter({ ...queryParameters });
        toasterContext?.addToast({
            body: translate("Document successfully downloaded"),
            messageType: "success",
            timeoutLength: 6000,
        });

        stateSetter(false);

        return true;
    } catch (e) {
        toasterContext?.addToast({
            body: translate(
                errorMessage || "Document is not available, please get in touch with Greif Customer Service",
            ),
            messageType: "danger",
            timeoutLength: 6000,
        });
        stateSetter(false);

        return false;
    }
};
